module.exports = __webpack_public_path__ + "img/Add.be840a26.svg";